// This file was generated by "make codegen/iam". DO NOT EDIT.

import { DEFAULT_POLICIES as ACTION_CNSPEC_POLICY_POLICYHUB_DEFAULTPOLICIES } from "~/lib/iam/actions/cnspec/policy/PolicyHub/DefaultPolicies/action";
import { GET_BUNDLE as ACTION_CNSPEC_POLICY_POLICYHUB_GETBUNDLE } from "~/lib/iam/actions/cnspec/policy/PolicyHub/GetBundle/action";
import { GET_MQUERY as ACTION_MONDOO_POLICY_REGISTRY_GETMQUERY } from "~/lib/iam/actions/mondoo/policy/Registry/GetMquery/action";
import { GET_POLICY as ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICY } from "~/lib/iam/actions/cnspec/policy/PolicyHub/GetPolicy/action";
import { GET_POLICY_FILTERS as ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICYFILTERS } from "~/lib/iam/actions/cnspec/policy/PolicyHub/GetPolicyFilters/action";
import { GET_RAW_BUNDLE as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETRAWBUNDLE } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetRawBundle/action";
import { LIST as ACTION_CNSPEC_POLICY_POLICYHUB_LIST } from "~/lib/iam/actions/cnspec/policy/PolicyHub/List/action";
import { LIST_CONTENT_CATEGORIES as ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTCATEGORIES } from "~/lib/iam/actions/mondoo/policy/Registry/ListContentCategories/action";
import { LIST_CONTENT_PLATFORMS as ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTPLATFORMS } from "~/lib/iam/actions/mondoo/policy/Registry/ListContentPlatforms/action";
import { LIST_MQUERIES as ACTION_MONDOO_POLICY_REGISTRY_LISTMQUERIES } from "~/lib/iam/actions/mondoo/policy/Registry/ListMqueries/action";
import { SEARCH_CONTENT as ACTION_MONDOO_POLICY_REGISTRY_SEARCHCONTENT } from "~/lib/iam/actions/mondoo/policy/Registry/SearchContent/action";
import { SET_BUNDLE as ACTION_CNSPEC_POLICY_POLICYHUB_SETBUNDLE } from "~/lib/iam/actions/cnspec/policy/PolicyHub/SetBundle/action";
import { VALIDATE_BUNDLE as ACTION_CNSPEC_POLICY_POLICYHUB_VALIDATEBUNDLE } from "~/lib/iam/actions/cnspec/policy/PolicyHub/ValidateBundle/action";

export const allowedActions = [
  ACTION_CNSPEC_POLICY_POLICYHUB_DEFAULTPOLICIES,
  ACTION_CNSPEC_POLICY_POLICYHUB_GETBUNDLE,
  ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICY,
  ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICYFILTERS,
  ACTION_CNSPEC_POLICY_POLICYHUB_LIST,
  ACTION_CNSPEC_POLICY_POLICYHUB_SETBUNDLE,
  ACTION_CNSPEC_POLICY_POLICYHUB_VALIDATEBUNDLE,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETRAWBUNDLE,
  ACTION_MONDOO_POLICY_REGISTRY_GETMQUERY,
  ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTCATEGORIES,
  ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTPLATFORMS,
  ACTION_MONDOO_POLICY_REGISTRY_LISTMQUERIES,
  ACTION_MONDOO_POLICY_REGISTRY_SEARCHCONTENT,
] as const;
